const Layout = () => import('@/layout/index.vue')

export default {
    path: '/msgManagement',
    component: Layout,
    redirect: '/msgManagement/index',
    name: 'MsgManagement',
    meta: {
        title: '消息通知',
        icon: 'home',
        auth: ['MsgManagement']
    },
    children: [
        {
            path: 'index',
            name: 'msgManagementIndex',
            component: () => import('@/views/msgManagement/index.vue'),
            meta: {
                title: '消息通知',
                sidebar: false,
                breadcrumb: false,
                activeMenu: '/home',
                auth: ['MsgManagement']
            }
        }
    ]
}
